import { render, staticRenderFns } from "./SelectFrame.vue?vue&type=template&id=78e9f63b&"
import script from "./SelectFrame.vue?vue&type=script&lang=js&"
export * from "./SelectFrame.vue?vue&type=script&lang=js&"
import style0 from "./SelectFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports